import { apiSlice } from "../apiSlice";
import { SUBJECTS_URL } from "../../constants";

export const subjectApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      createSubject: builder.mutation({
        query: (data) => ({
          url: `${SUBJECTS_URL}/createsubject`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Subjects'],
      }),
      getSubjects: builder.query({
        query: ({ pageNumber }) => ({
          url: `${SUBJECTS_URL}/teachersubjects`,
          params: {
            pageNumber,
        },
        }),
        providesTags: ['Subjects'], 

      }),
      getPublicsubjects: builder.query({
        query: (id) => ({
          url: `${SUBJECTS_URL}/publicsubjects/${id}`,
        }),
      }),
      getPublicsubject: builder.query({
        query: (id) => ({
          url: `${SUBJECTS_URL}/teacherpublicsubject/${id}`,
        }),
        providesTags: ['Subjects'],
      }),
      getPlanQuestions: builder.query({
        query: (id) => ({
          url: `${SUBJECTS_URL}/getplanquestions/${id}`,
        }),
        invalidatesTags: ['Subjects', 'Plans'],
      }),
      updateSubject: builder.mutation({
        query: (data) => ({
          url: `${SUBJECTS_URL}/updatesubject`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: ['Subjects'], 
      }),
    }),
});

export const { 
  useCreateSubjectMutation, 
  useGetSubjectsQuery,
  useGetPublicsubjectsQuery,
  useGetPublicsubjectQuery,
  useUpdateSubjectMutation,
  useGetPlanQuestionsQuery
} = subjectApiSlice;
